import { render, staticRenderFns } from "./UploadXML.vue?vue&type=template&id=56841b29&style=overflow%3A%20visible%3B%20z-index%3A%20300&"
import script from "./UploadXML.vue?vue&type=script&lang=js&"
export * from "./UploadXML.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports